var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"play-row",class:[
    _vm.alignH ? ("play-row--justify-" + _vm.alignH) : null,
    _vm.alignV ? ("play-row--align-" + _vm.alignV) : null,
    { 'play-row--no-gutters': _vm.noGutters } ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }